export function createSearchParams(selectedLocation: string | null, selectedBudget: string | null, selectedPropertyType: string | null, possessionId?: string | null) {
  const searchParams = new URLSearchParams();
  
  // Map location
  if (selectedLocation) {
    searchParams.append("locality", selectedLocation);
  }
  
  // Map budget ranges to minPrice and maxPrice
  if (selectedBudget) {
    switch (selectedBudget) {
      case 'budget-1':
        searchParams.append("minPrice", "0");
        searchParams.append("maxPrice", "10000000"); // Under 1 crore
        break;
      case 'budget-2':
        searchParams.append("minPrice", "10000000");
        searchParams.append("maxPrice", "20000000"); // 1-2 crores
        break;
      case 'budget-3':
        searchParams.append("minPrice", "20000000");
        searchParams.append("maxPrice", "40000000"); // 2-4 crores
        break;
      case 'budget-4':
        searchParams.append("minPrice", "40000000"); // Over 4 crores
        searchParams.append("maxPrice", "999999999"); 
        break;
    }
  }
  
  // Map property type
  if (selectedPropertyType) {
    searchParams.append("homeType", selectedPropertyType);
  }
  
  // Map possession time
  if (possessionId) {
    searchParams.append("possession", possessionId);
  }

  return searchParams;
} 